import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import OMCDataList from './OMCList';

class OMC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      omc_name: '',
      web_image: null,
      mobile_image: null,
      uuid: '',
      time_stamp: dayjs().format('YYYY-MM-DD'),
      updated: false,
      editMode: false,
      isSubmitting: false,
    };
    this.editRef = React.createRef();
  }

  handleDate = (e) => {
    this.setState({ time_stamp: e.target.value });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFileUpload = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      const formattedName = `image:${new Date()
        .toISOString()
        .replace(/[:-]/g, '')
        .replace(/\.\d{3}/, '')}.${file.name.split('.').pop()}`;

      this.setState((prevState) => ({
        ...prevState,
        [field]: {
          file,
          formattedName,
        },
      }));
    }
  };

  handleEditMode = (item) => {
    this.setState({
      omc_name: item.omc,
      web_image: item.web_logo
        ? { formattedName: item.web_logo.split('/').pop(), file: null }
        : null,
      mobile_image: item.mobile_logo
        ? { formattedName: item.mobile_logo.split('/').pop(), file: null }
        : null,
      uuid: item.uuid || '',
      editMode: true,
      updated: !this.state.updated,
    });
  };

  confirmSubmit = (e) => {
    const { omc_name } = this.state;
    confirmAlert({
      title: 'Are you sure you want to',
      message: this.state.editMode ? `update ${omc_name}` : 'add a new OMC',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };
  submitForm = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });

    const formData = new FormData();
    formData.append('omc_name', this.state.omc_name);
    formData.append('time_stamp', this.state.time_stamp);

    if (this.state.web_image?.file) {
      formData.append(
        'web_image',
        this.state.web_image.file,
        this.state.web_image.formattedName,
      );
    }
    if (this.state.mobile_image?.file) {
      formData.append(
        'mobile_image',
        this.state.mobile_image.file,
        this.state.mobile_image.formattedName,
      );
    }

    const headers = {
      ...authHeader(),
      'Content-Type': 'multipart/form-data',
    };

    const url = `${process.env.API_URL}/bunk/omc/omc-set/`;

    if (this.state.editMode) {
      axios
        .put(
          url,
          formData,
          { headers },
          formData.append('uuid', this.state.uuid),
        )
        .then(() => {
          toast.success('OMC updated successfully');
          this.resetForm();
        })
        .catch((err) => {
          toast.error(
            err?.response?.data?.message || 'Error occurred while updating',
          );
          this.setState({ isSubmitting: false });
        });
    } else {
      axios
        .post(url, formData, { headers })
        .then(() => {
          toast.success('OMC added successfully');
          this.resetForm();
        })
        .catch((err) => {
          toast.error(
            err?.response?.data?.message || 'Error occurred while adding',
          );
          this.setState({ isSubmitting: false });
        });
    }
  };

  resetForm = () => {
    this.setState({
      omc_name: '',
      web_image: '',
      mobile_image: '',
      time_stamp: dayjs().format('YYYY-MM-DD'),
      editMode: false,
      updated: !this.state.updated,
      isSubmitting: false,
    });

    if (this.editRef.current) {
      window.scrollTo({
        behavior: 'smooth',
        top: this.editRef.current.offsetTop - 150,
      });
    }
  };

  cancelEdit = () => {
    this.setState({
      omc_name: '',
      web_image: null,
      mobile_image: null,
      time_stamp: dayjs().format('YYYY-MM-DD'),
      editMode: false,
    });
  };

  render() {
    const { editMode } = this.state;
    return (
      <>
        <section className="widget full-width form-table">
          <header>
            <h3>{editMode ? 'Edit OMC' : 'Add OMC'}</h3>
          </header>
          <main>
            <div className="form-header">
              <div className="input-wrapper">
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.time_stamp}
                  onChange={this.handleDate}
                />
              </div>
            </div>
            <div className="form-content">
              <table>
                <thead>
                  <tr>
                    <th>OMC Name</th>
                    <th>Mobile Logo</th>
                    <th>Web Logo</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className={`${editMode ? 'highlight-bg' : ''}`}>
                    <td>
                      <div className="input-wrapper">
                        <input
                          name="omc_name"
                          type="text"
                          onChange={this.handleChange}
                          placeholder="OMC name"
                          value={this.state.omc_name}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="actions">
                        <div className="input-wrapper file-upload">
                          <div
                            className="input-group"
                            style={{ display: 'flex' }}
                          >
                            <input
                              type="file"
                              id="mobile-image-upload"
                              name="mobile_image"
                              onChange={(e) =>
                                this.handleFileUpload(e, 'mobile_image')
                              }
                              accept=".png, .jpg, .jpeg"
                              placeholder="Upload Mobile Logo"
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="actions">
                        <div className="input-wrapper file-upload">
                          <div
                            className="input-group"
                            style={{ display: 'flex' }}
                          >
                            <input
                              type="file"
                              id="web-image-upload"
                              name="web_image"
                              onChange={(e) =>
                                this.handleFileUpload(e, 'web_image')
                              }
                              accept=".png, .jpg, .jpeg"
                              placeholder="Upload Web Logo"
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="form-actions">
                <button
                  className="submit"
                  type="submit"
                  onClick={this.confirmSubmit}
                >
                  Submit
                </button>
                {editMode && (
                  <button className="red-btn" onClick={this.cancelEdit}>
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </main>
        </section>
        <OMCDataList key={this.state.updated} onEdit={this.handleEditMode} />
      </>
    );
  }
}

export { OMC };
